module.exports = __webpack_public_path__ + "static/media/icon-download.05d0259e.svg";